export enum SourceType {
  MANUAL = 'MANUAL',
  VIDEO = 'VIDEO',
  PROCEDURE = 'PROCEDURE',
  REPORT = 'REPORT',
  DATABASE = 'DATABASE',
  MIX_DESIGN = 'MIX_DESIGN',
  LAB_RESULT = 'LAB_RESULT',
}
